export const COLLECTION_NAME_MAP = {
  newsletters: 'Boletines o alertas',
  videos: 'Videos',
  podcasts: 'Audios',
  releases: 'Comunicados',
  critical_standars: 'Estándares Críticos',
  policies: 'Políticas',
  reports: 'Reportes',
  links: 'Enlaces',
  galleries: 'Galerías',
  banners: 'Banners',
};
